import React, { useEffect, useState } from "react"
import { Card, Col, Row } from "reactstrap"
import toast from "react-hot-toast"
import moment from "moment"

import {
   AddGetProductionLinesOverrides,
   DeleteProductionLinesOverrides,
   GetProductionLineDetails,
   UpdateProductionLinesOverrides,
} from "api/api.service"

import { Button } from "components/Button"
import { DataTable } from "components/DataTable"
import { Modal } from "components/Modal"
import { convertDateTime, dateTimeFormat } from "utils/dateFormatUtils"
import DeleteOverrideModal from "./Modals/DeleteOverrideModal"
import Overrides from "./Overrides/Overrides"
import { APP_ROUTES } from "helpers/routeHelpers"
import OverridesDatesSkeleton from "./ProductionLineSkeleton/OverridesDatesSkeleton"

import EditIcon from "assets/images/icons/edit-icon.svg"
import DeleteIcon from "assets/images/icons/finance-vendor-mang-del-icon.svg"

const sortStagesDataBysequenceNo = data => {
   return data?.sort((a, b) => a.sequenceNo - b.sequenceNo)
}
const COLUMNS = {
   DATE_ADDED: "Date Added",
   TO_DATE: "To Date",
   PREMIUM_SLOTS: "Premium Slots",
   REGULAR_SLOTS: "Regular Slots",
   NUMBER_OF_SLOTS: "Number of Slots",
   ACTIONS: "Actions",
}

const TOTAL_SLOTS = 0 // Define your total slots constant

const initialSelection = {
   id: null,
   dateFrom: null,
   dateTo: null,
   noOfSlots: TOTAL_SLOTS,
   premiumSlots: 0,
   regularSlots: 0,
}

const ProductionLineDetailsOverrides = props => {
   const { isLoading, productionLineId, hasOrders } = props
   const [selection, setSelection] = useState(initialSelection)
   const [isOpen, setIsOpen] = useState(false)
   const [actionKey, setActionKey] = useState("")
   const [loading, setLoading] = useState(false)
   const [localData, setLocalData] = useState([])

   useEffect(() => {
      handleFetchDateOverrides()
   }, [])
   const handleModalClose = () => {
      setSelection(initialSelection)
      setActionKey("")
      setIsOpen(false)
   }

   const handleAction = (data = {}, actionName = "") => {
      setSelection(data)
      setActionKey(actionName)
      setIsOpen(true)
   }

   const handleFetchDateOverrides = async () => {
      try {
         setLoading(true)
         const res = await GetProductionLineDetails(productionLineId)
         setLocalData(sortStagesDataBysequenceNo(res?.overrides))
         return res
      } catch (error) {
         history.push(APP_ROUTES.PRODUCTION_LINE_MANAGEMENT)
         toast.error("Production Line does not exist!")
      } finally {
         setLoading(false)
      }
   }

   const handleSubmit = formData => {
      let payload = {
         dateFrom: moment(formData.startDate).format("YYYY-MM-DD"),
         dateTo: moment(formData.endDate).format("YYYY-MM-DD"),
         noOfSlots:
            Number(formData.premiumSlots) + Number(formData.regularSlots),
         premiumSlots: Number(formData.premiumSlots),
      }

      switch (actionKey) {
         case "ADD":
            return handleAdd(payload)
         case "UPDATE":
            return handleEdit(payload)
         case "DELETE":
            return handleDelete()
         default:
            return
      }
   }

   const handleAdd = async bodyData => {
      try {
         setLoading(true)
         let payload = {
            ...bodyData,
            productionLineId: Number(productionLineId),
         }
         await AddGetProductionLinesOverrides(payload)
         const res = await handleFetchDateOverrides()
         toast.success("Date overrides has been added")
         setLocalData(sortStagesDataBysequenceNo(res?.overrides))
         handleModalClose()
      } catch (error) {
         console.error(error.message || "Failed to add override")
      } finally {
         setLoading(false)
      }
   }

   const handleEdit = async payload => {
      try {
         setLoading(true)
         handleModalClose()
         await UpdateProductionLinesOverrides(selection.id, payload)
         const res = await handleFetchDateOverrides()
         setLocalData(sortStagesDataBysequenceNo(res?.overrides))
         toast.success("Date overrides has been updated")
         handleModalClose()
      } catch (error) {
         console.error(error.message || "Failed to update override")
      } finally {
         setLoading(false)
      }
   }

   const handleDelete = async () => {
      try {
         setLoading(true)
         handleModalClose()
         await DeleteProductionLinesOverrides(selection.id)
         const res = await handleFetchDateOverrides()
         setLocalData(sortStagesDataBysequenceNo(res?.overrides))
         toast.success("Date overrides has been deleted")
      } catch (error) {
         toast.error(error.message || "Failed to delete override")
      } finally {
         setLoading(false)
      }
   }

   return (
      <>
         {loading ? (
            <OverridesDatesSkeleton />
         ) : (
            <>
               <div className="trailer-container p-4">
                  <div className="d-flex align-items-center justify-content-end admin-inventory-management-general-inventory-responsiveness trailer-btn-container">
                     <Button
                        className="header-button headerButtonResponsive"
                        title="Add Overrides"
                        onClick={() => handleAction(initialSelection, "ADD")}
                     />
                  </div>
               </div>

               <Card>
                  <Row>
                     <Col md={12}>
                        <DataTable
                           data={localData}
                           tableClasses="trailer-management-table"
                           className="table-responsive scroll-container"
                           loading={isLoading}
                           config={[
                              {
                                 title: COLUMNS.DATE_ADDED,
                                 className: "",
                                 render: data =>
                                    convertDateTime({
                                       date: data.dateFrom,
                                       customFormat:
                                          dateTimeFormat.americanFormat,
                                       dateOnly: true,
                                       utc: true,
                                    }),
                              },
                              {
                                 title: COLUMNS.TO_DATE,
                                 className: "",
                                 render: data =>
                                    convertDateTime({
                                       date: data.dateTo,
                                       customFormat:
                                          dateTimeFormat.americanFormat,
                                       dateOnly: true,
                                       utc: true,
                                    }),
                              },
                              {
                                 title: COLUMNS.REGULAR_SLOTS,
                                 className: "",
                                 render: data => data.regularSlots ?? "-",
                              },
                              {
                                 title: COLUMNS.PREMIUM_SLOTS,
                                 className: "",
                                 render: data => data.premiumSlots ?? "-",
                              },
                              {
                                 title: COLUMNS.NUMBER_OF_SLOTS,
                                 className: "",
                                 render: data => data.noOfSlots ?? "-",
                              },

                              {
                                 title: COLUMNS.ACTIONS,

                                 render: data => (
                                    <div className="d-flex gap-2 pointer">
                                       <img
                                          src={EditIcon}
                                          onClick={() =>
                                             handleAction(data, "UPDATE")
                                          }
                                       />
                                       <img
                                          src={DeleteIcon}
                                          onClick={() =>
                                             handleAction(data, "DELETE")
                                          }
                                       />
                                    </div>
                                 ),
                              },
                           ]}
                        />
                     </Col>
                  </Row>
               </Card>
            </>
         )}

         {/* Add/Edit Modal */}
         {isOpen && ["ADD", "UPDATE"].includes(actionKey) && (
            <Modal
               isOpen={isOpen && ["ADD", "UPDATE"].includes(actionKey)}
               handleModalToggling={handleModalClose}
               customButton
               hideModalHeaderSeparator
               headerClasses="header-container"
               backdrop="static"
               modalTitle={`${actionKey === "ADD" ? "Add" : "Edit"} Overrides`}
               size="lg"
               bodyClassName="override-modal"
            >
               <Overrides
                  override={selection}
                  actionName={actionKey}
                  isLoading={loading}
                  onSubmit={handleSubmit}
               />
            </Modal>
         )}

         {/* Delete Modal */}
         {isOpen && actionKey === "DELETE" && (
            <Modal
               isOpen={isOpen && actionKey === "DELETE"}
               handleModalToggling={handleModalClose}
               customButton={true}
               hideModalHeaderSeparator={true}
               headerClasses="header-container"
               backdrop="static"
               modalTitle="Delete Overrides"
               size="md"
            >
               <DeleteOverrideModal
                  isLoading={loading}
                  onDeleteClick={handleSubmit}
                  onCancelClick={handleModalClose}
               />
            </Modal>
         )}
      </>
   )
}

export default React.memo(ProductionLineDetailsOverrides)
